import { apiClient } from "@base/api/client";
import { useQuery } from "@tanstack/react-query";

export type CurrentUser = {
  id: number;
  name: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  phone_number_country_code: number;
  uuid: string;
  service_due_date: string | null;
  foreign_direct_investment_status: string | null;
  is_email_verified: boolean;
  source: string;
  is_agreed_to_ad_term: boolean;
};

type CurrentUserResponse = {
  user: CurrentUser;
  roles: string[];
};

export async function fetchCurrentUser(): Promise<CurrentUserResponse> {
  const response = await apiClient.get<CurrentUserResponse>("/api/user");
  return response.data;
}

export const currentUserQueryOptions = {
  queryKey: ["currentUser"] as const,
  queryFn: fetchCurrentUser,
  staleTime: 1000 * 60 * 10,
};

export function useCurrentUserQuery() {
  return useQuery(currentUserQueryOptions);
}
